/**
 * Status service for checking backend health
 */

import { apiClient } from './client'
import type { StatusResponse } from '@/types/api'

export const statusService = {
  /**
   * Check the backend status (public endpoint, no auth required)
   */
  async getStatus(): Promise<StatusResponse> {
    return apiClient.get<StatusResponse>('/status')
  },

  /**
   * Check if the backend is healthy
   * Returns true if status endpoint responds successfully with healthy status
   */
  async isHealthy(): Promise<boolean> {
    try {
      const status = await this.getStatus()
      return status.status === 'healthy'
    } catch {
      return false
    }
  },
}
